module.exports = __webpack_public_path__ + "img/HU10644371.1aafdccd.png";